<template>
  <div class="issues-list-collection-container">
    <div class="issues-list-collection">
      <IssuesListItem v-for="(issue, index) in issuesList" :issue="issue" :key="index" />
    </div>
  </div>
</template>

<script>
import IssuesListItem from '@/issues/IssuesListItem.vue';

export default {
  props: ['issuesList'],
  components: {
    IssuesListItem,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.issues-list-collection {
  display: flex;
  flex-direction: column;
}
</style>
